module.exports = __webpack_public_path__ + "img/Background6.cf69c8c3.png";